<template>
    <auth-layout :isPlain="true" :progress="0" :isProgressBarHidden="true">
        <common-content-wrapper width="small">
            <common-content-spacer height="large">
                <common-icon v-if="isManager" name="success" size="ultra-large"></common-icon>
                <div>
                    <div v-if="headerTitle">
                        <common-page-header :heading="headerTitle"></common-page-header>
                    </div>
                    <div v-else>
                        <common-page-header
                            :heading="$t('pages.auth.signup.steps.congratulations.mobile.thank_you')"
                        ></common-page-header>
                        <common-page-header :heading="$auth.getUser().practiceName"></common-page-header>
                    </div>
                </div>
            </common-content-spacer>
        </common-content-wrapper>

        <common-content-wrapper width="small">
            <div class="page-copy">
                <p class="page-copy__center">
                    <svg style="height: 91px"><use xlink:href="#picture-desktop" /></svg>
                </p>
            </div>
        </common-content-wrapper>

        <common-content-wrapper width="small">
            <common-page-copy size="major">
                <p class="page-copy__center">
                    <!-- eslint-disable-next-line vue/no-v-html -->
                    <strong v-html="$t('pages.auth.signup.steps.congratulations.mobile.warning_non_master_users')"></strong>
                </p>
            </common-page-copy>
        </common-content-wrapper>
    </auth-layout>
</template>

<script>
    import AuthLayout from 'components/layouts/AuthLayout'
    import FormMixin from 'mixins/FormMixin'

    export default {
        mixins: [FormMixin],

        components: {
            AuthLayout,
        },

        props: {
            headerTitle: { type: String, required: false, default: '' },
        },

        data() {},

        mounted() {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = 'mobile'
        },

        beforeDestroy: function () {
            //THIS SHOULD BE REMOVED WHEN RESPONSIVE IS IMPLEMENTED
            document.body.className = ''
        },
    }
</script>
